
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-star-line',
      title: 'Qualidade Premium',
      description: 'Aço inoxidável de alta qualidade com lâminas ultra afiadas com revestimento antiaderente que mantêm o corte suave, e por muito mais tempo'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Design Ergonômico',
      description: 'Cabos ergonômicos que proporcionam conforto e segurança durante o uso prolongado na cozinha ou churrasco'
    },
    {
      icon: 'ri-time-line',
      title: 'Economia de Tempo',
      description: 'Cortes mais rápidos e precisos que aceleram o preparo dos alimentos e melhoram os resultados'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Durabilidade Garantida',
      description: 'Materiais resistentes à corrosão e ao desgaste, garantindo anos de uso intensivo'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Organização Perfeita',
      description: 'Você conta com um Kit premium completo que cada peça é destinada a preparos diversificados na sua cozinha, sendo o seu kit essencial para todos os momentos'
    },
    {
      icon: 'ri-medal-line',
      title: 'Resultado Profissional',
      description: 'Transforme pratos simples em criações dignas de restaurante com cortes perfeitos'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Por Que Escolher Nosso Kit?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Descubra as vantagens que fazem a diferença na sua cozinha
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-md hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className={`${benefit.icon} text-3xl text-red-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3 text-center">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
